module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-bar-down-9fce45e6.svg";